export default {
  appName: "Antipartido",
  notificationText: "Instalar Antipartido",
  buttonText: "Instalar",
  installQuestion: "¿Instalar Antipartido en tu teléfono?",
  tapToInstall: "Instalar",
  incompatibleBrowserTitle: "Tu navegador no es compatible",
  incompatibleBrowserMessage: "Abre este enlace en Safari o Chrome para instalar la app.",
  incompatibleBrowserCopyLink: "Copiar enlace",
  incompatibleBrowserLinkCopied: "¡Enlace copiado!",
  iosStep1: "Toca <shareButton /> en la barra del navegador (en Safari dentro de <moreButton />)",
  iosStep2: "Desplázate y toca <addToHomeScreen />",
  shareText: "Compartir",
  moreText: "Más",
  addToHomeScreenText: "Añadir a pantalla de inicio",
  iosStep3: "Si no aparece, toca \"Ver más\" al final del menú",
}
